import { UploadFile } from 'antd';
import { UploadChangeParam } from 'antd/es/upload';

import { FormItemLabelType, TDtoWrapper } from '@/shared/lib/forms/form-wrapper.types';
import { BaseDto } from '@/shared/lib/sj-orm/models/base.dto';
import { QuestionType } from '@/shared/lib/sj-orm/models/form/question.dto';
import { TimeDurationUnitsEnum } from '@/shared/lib/sj-orm/models/form/question-option.dto';
import { DeepPartial } from '@/shared/types/utility-types';

import { separator } from './constants';

type OmittedBaseDto = Omit<BaseDto, 'id'>;
export type UseFormRenderInputType<
  TDto extends OmittedBaseDto,
  THelp extends { [TKey in keyof TDto]: QuestionType },
> = {
  form: TDtoWrapper<TDto, THelp>;
  texts?: { [key: string]: FormItemLabelType };
  onSubmit?: (data: TDto) => void;
  onDelegationSubmit?: (data: TDto) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultValues?: DeepPartial<TDto & any>;
  removeAllRequired?: boolean;
  isLastStep?: boolean;
  withDelegation?: boolean;
  withSaveButton?: boolean;
  validateOnMount?: boolean;
};

type DefaultInputType =
  | QuestionType.URL
  | QuestionType.TEXT
  | QuestionType.EMAIL
  | QuestionType.NUMBER;

export const InputsWithPlaceholder = [
  QuestionType.URL,
  QuestionType.TEXT,
  QuestionType.NUMBER,
  QuestionType.EMAIL,
];

export const isDefaultInput = (type: QuestionType): type is DefaultInputType =>
  InputsWithPlaceholder.includes(type);

export const DefaultInputToInputType: Record<DefaultInputType, string> = {
  [QuestionType.URL]: 'url',
  [QuestionType.TEXT]: 'text',
  [QuestionType.NUMBER]: 'number',
  [QuestionType.EMAIL]: 'email',
};

export type KeyString<T = string> = { key: T };

export type FormItemKey = `${QuestionType}${typeof separator}${string}${typeof separator}${string}`;

export type ReturnedTypesDefault =
  | boolean
  | string
  | number
  | KeyString
  | KeyString<TimeDurationUnitsEnum>
  | Array<string>
  | UploadChangeParam<UploadFile>;

export type ReturnedTypes<T = ReturnedTypesDefault> = T;

export type FormItemsType = {
  [key: FormItemKey]: ReturnedTypes;
};
